import styled from "styled-components";

export const Container = styled.div`
	min-height: 100vh;
	width: 100%;

	display: flex;
	justify-content: center;
	align-items: center;
	background-image: url(${props => props.bgColor !== "../../assets/images/BackgroundImage.jpg" ? props.bgColor : "../../assets/constellation (2).jpg"});
	background-position: center center;
	background-size: 100% 100vh;

	color: white !important;
	position:relative;
	top:68px;
`

export const SubContainer = styled.div`
	width: 100%;
	height: 95%;
`

export const HeadingContainer = styled.div`
	width: 100%;
	padding-top: 1rem;
	padding-bottom: 1.5rem;
	margin-bottom: 1.5rem;
	display: flex;
	justify-content: center;
	border-bottom: 3px solid white;
	
`

export const Heading = styled.h1`
	font-size: 2rem;
	font-weight: 600;
    text-shadow: 0.5px 0.5px 1px whitesmoke;
`

export const CardContainer = styled.div`
	width: 100%;
	min-height: 80%;

	display: flex;
	justify-content: space-around;
	flex-wrap: wrap;
`